// extracted by mini-css-extract-plugin
export default {"LogoContainer":"Logo_LogoContainer__4bj0p","Logo":"Logo_Logo__V+cXg"};